import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import { WalletProvider } from "./lib/wallet";
import Overview from "./pages/Overview";
import Tokens from "./pages/Tokens";
import TokenDetail from "./pages/TokenDetail";
import Heatmap from "./pages/Heatmap";
import Stocks from "./pages/Stocks";
import Wallets from "./pages/Wallets";
import WalletDetail from "./pages/WalletDetail";
import Explorer from "./pages/Explorer";
import ExplorerTx from "./pages/ExplorerTx";
import ExplorerBlock from "./pages/ExplorerBlock";
import Watchlist from "./pages/Watchlist";
import Alerts from "./pages/Alerts";

function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/tokens" element={<Tokens />} />
            <Route path="/heatmap" element={<Heatmap />} />
            <Route path="/token/:address" element={<TokenDetail />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/accounts" element={<Wallets />} />
            <Route path="/wallet/:address" element={<WalletDetail />} />
            <Route path="/explorer" element={<Explorer />} />
            <Route path="/explorer/tx/:hash" element={<ExplorerTx />} />
            <Route path="/explorer/block/:number" element={<ExplorerBlock />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/alerts" element={<Alerts />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", border: "1px solid #262626", color: "#F3F4F6" } }} />
    </WalletProvider>
  );
}

export default App;
